import React, { useEffect, useState, useRef } from 'react';
import './LiveCut.scss';
import { IComponentLiveCut } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { IMedium } from '../../store/VideoStore';
import RootStore from '../../store/RootStore';
import { style } from '../../utils/image';
import ReactSVG from 'react-svg';
import intl from 'react-intl-universal';
import { formatDuration } from '../../utils/video';

interface ILiveCut extends IComponentLiveCut {
  rootStore?: RootStore;
  onPlayVideo: (item: IMedium, index: number) => void;
  inSearch?: string;
  currentIndex: number;
  cid: string;
}

const Index = (props: ILiveCut) => {
  const { inSearch, rootStore, mode, onPlayVideo, currentIndex, cid} = props;
  const { videoStore } = rootStore!;
  const { h1Color, h2Color, mainColor } = useTheme();

  let livecut_search = videoStore.livecut_search[cid] || {
    items:[],
    total:-1
  };
  let livecut_list = videoStore.livecut_list[cid] || {
    items:[],
    total:-1
  };

  let list = !!inSearch ? livecut_search.items : livecut_list.items;
  let total = !!inSearch ? livecut_search.total : livecut_list.total;

  const renderMode3 = (it: IMedium, index: number) => {
    let options = {} as any;
    try {
      options = JSON.parse(it.options);
    }catch(e) {}

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className="livecut-item type-3"
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`} />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
            {options.remark ? <div className="remark" style={{color:h2Color}}>{options.remark}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  const renderMode2 = (it: IMedium, index: number) => {
    let options = {} as any;
    try {
      options = JSON.parse(it.options);
    }catch(e) {}

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className="livecut-item type-2"
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`} />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
            {options.remark ? <div className="remark" style={{color:h2Color}}>{options.remark}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  const renderMode1 = (it:IMedium, index:number)=>{
    let options = {} as any;
    try {
      options = JSON.parse(it.options);
    }catch(e) {}

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className="livecut-item type-1"
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`} />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderItem = (it: IMedium, index: number) => {
    if (currentIndex >= 0) {
      return (
        <div className="liveshow-item" key={it.id}>
          <div className="wrapper">
            <div style={{ paddingBottom: mode == 'h' ? '56%' : '177%' }} />
          </div>
        </div>
      );
    }
    if(mode == '3') {
      return renderMode3(it, index);
    }
    if (mode == '2') {
      return renderMode2(it, index);
    }
    if (mode == '1') {
      return renderMode1(it, index);
    }
  };

  const renderEmpty = () => {
    if (typeof total != 'undefined' && total > -1) {
      if (!!props.inSearch) {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('Not found any video')}</p>
          </div>
        );
      } else {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('No hot video')}</p>
          </div>
        );
      }
    }

    return null;
  };
  console.log(`livecut search`, videoStore.livecut_search);
  return (
    <div className={`livecut mode${mode}`}>
      {!!inSearch && videoStore.livecut_search[cid]?.total == 0
        ? renderEmpty()
        : list && list.length
        ? list.map(renderItem).filter(Boolean)
        : renderEmpty()}
    </div>
  );
};

export default inject('rootStore')(observer(Index));
